import { render, staticRenderFns } from "./RenameResponsibilityDialog.vue?vue&type=template&id=2f275925&scoped=true"
import script from "./RenameResponsibilityDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./RenameResponsibilityDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RenameResponsibilityDialog.vue?vue&type=style&index=0&id=2f275925&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f275925",
  null
  
)

export default component.exports